/**
 * Connect Google My Business page in LOG
 *
 * @author Nicholas Cassleman (ncassleman@yext.com)
 */

goog.provide('yext.storm.log.gmb');

goog.require('yext');
goog.require('yext.notify');
goog.require('yext.ui.RadioFilter');
goog.require('yext.storm.Introduction');
goog.require('yext.dialog');


/**
 * Initializes the RadioFilter and submit button on both the Choose User Account
 * page and Choose Business Account page, whose HTML structure is identical
 * regarding the functionality provided in this function
 */
yext.storm.log.gmb.initChooseAccountPage = function() {
  // set up radio filter for user accounts
  new yext.ui.RadioFilter($('.js-radiofilter'));
  const continueBtn = document.querySelector('.js-gmb-continue-btn');

  function waitForAccountsToLoad(selector) {
    return new Promise(resolve => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(() => {
        if (document.querySelector(selector)) {
          observer.disconnect();
          resolve(document.querySelector(selector));
        }
      });

      observer.observe(document.querySelector('.social-container'), {
        childList: true,
        subtree: true,
      });
    });
  }

  // We should not allow end-users to continue the flow until the radio button choices have appeared
  // This is because the next page depends on a value to be chosen.
  continueBtn.style.display = 'none';
  waitForAccountsToLoad('.radiofilter-items').then(() => {
    continueBtn.style.display = 'inline-flex';
  });

  // set up disjointed submit button
  $('.js-gmb-continue-btn').on('click', function() {
    $('.js-gmb-main-form').submit();
  });
};

/**
 * Initializes the manual account matching page
 *
 * @constructor
 * @param {string} gmbMatchDataUrl Endpoint called by AJAX to return match data
 * @param {string} goalId Current goal ID in the LOG flow
 * @param {string=} brandName Whitelabel name. Defaults to Yext
 */
yext.storm.log.gmb.GmbMatchPage = function(gmbMatchDataUrl, goalId, brandName='Yext') {
  this.$container = $('.social-intro-match-network');
  this.$form = $('.js-match-form');
  this.partnerId = this.$container.data('partnerId');
  this.goalId = goalId;
  this.$submitBtn = $('.js-gmb-continue-btn');

  this.loadData(gmbMatchDataUrl);
  this.bindEventHandlers(brandName);
};

/**
 * Binds all event handlers related to page
 *
 * @param {string=} brandName Whitelabel name. Defaults to Yext
 */
yext.storm.log.gmb.GmbMatchPage.prototype.bindEventHandlers = function(brandName='Yext') {
  const self = this;

  // submit button submits form
  this.$submitBtn.on('click', function(e) {
    e.preventDefault();
    if (self.partnerId === 715 && self.hasMatchWithVerifiedDiscrepancyLocation()) {
      self.showWarningBeforeSubmitDialog(
        yext.msg('You are syncing with a verified listing or a listing that is pending verification. Any change to your listing data on Google Business Profile could require reverification of your location. To learn more, click <a href="https://support.google.com/business/answer/3534420">here</a>. <br> If you are changing important location data, like Name, Address, Phone, or Category, we recommend making this change in Google Business Profile or {0} Knowledge Engine before syncing your listing with {0}.', brandName),
        yext.msg('Content Change'));
    } else {
      self.submit();
    }
  });
};

/**
 * Loads the GMB data via AJAX and places it in a container
 *
 * @param {string} gmbMatchDataUrl Endpoint that returns HTML containing matches
 */
yext.storm.log.gmb.GmbMatchPage.prototype.loadData = function(gmbMatchDataUrl) {
  const self = this;

  $.ajax({
    url: gmbMatchDataUrl,
    dataType: 'html',
    type: 'GET',
    success: function(data) {
      self.onLoadSuccess(data);
    },
    error: function() {
      const $errorMsg = $('<p class="error-message"/>');
      $errorMsg.text(yext.msg('There was an error processing your request.'));
      self.$container.html($errorMsg);
    },
  });
};

/**
 * Addtional setup required by the page upon loading
 *
 * @param {string} data HTML to load into the page
 */
yext.storm.log.gmb.GmbMatchPage.prototype.onLoadSuccess = function(data) {
  const self = this;

  this.$container.html(data);
  this.isSingleLocation = this.$container.find('.js-match-rows').data('singleLocation');

  yext.storm.Introduction.bindConnectAccount();

  if (!this.isSingleLocation) {
    // bind gumi (multi location)
    const gumiConfig = $.extend({}, yext.gumiConfig, {
      onChange: function() {
        const $this = $(this);
        const locationId = $this.closest('.js-gmb-match-row').data('locationId');
        const externalId = $this.val();
        yext.storm.log.gmb.GmbMatchPage.removeDuplicates(locationId, externalId);
      },
      buttonTextOnly: false,
      buttonClass: 'gmb-button',
    });
    $('.gumi').gumi(gumiConfig);

    // remove any initial duplicates
    $('.js-gmb-match-row').each(function() {
      const $row = $(this);
      yext.storm.log.gmb.GmbMatchPage.removeDuplicates(
        $row.data('locationId'),
        $row.find('select').val());
    });
  }
};

/**
 * Builds an array containing matched locations based on current selections
 *
 * @return {!Array<Object>} An array of objects containing info on manual matches
 */
yext.storm.log.gmb.GmbMatchPage.prototype.buildCurrentLocationMap = function() {
  const locationMatches = [];
  const self = this;
  const singleLocation = $('.js-match-rows').data('singleLocation');
  const inputType = singleLocation ? 'input' : 'select';

  $('.js-gmb-match-row').each(function() {
    const $row = $(this);
    const locationId = $row.data('locationId');
    if (singleLocation) {
      var externalId = $row.find(inputType).filter(':checked').val();
      if (!externalId || !externalId.length) {
        externalId = 'skip'; // nothing checked
      }
    } else {
      var externalId = $row.find(inputType).val();
    }
    if (externalId === 'new') {
      externalId = '';
    }
    if (externalId !== 'skip') {
      locationMatches.push({
        'partnerId': self.partnerId,
        'externalId': externalId,
        'locationId': locationId,
      });
    }
  });

  return locationMatches;
};

/**
 * Determine whether or not there is external location select with 'Verifed' status and has discrepancy from Yext location
 *
 * @return {boolean} True if there is a location selected with 'Verifed' status and has discrepancy from Yext location
 */
yext.storm.log.gmb.GmbMatchPage.prototype.hasMatchWithVerifiedDiscrepancyLocation = function() {
  const self = this;
  const singleLocation = $('.js-match-rows').data('singleLocation');
  const inputType = singleLocation ? 'input' : 'li';
  let hasMatchWithVerifiedDiscrepancyLocation = false;
  const locationMatches = self.buildCurrentLocationMap();
  const externalIds = [];
  for (let i = 0; i<locationMatches.length; i++) {
    externalIds.push(locationMatches[i].externalId);
  }
  $('.js-gmb-match-row').each(function() {
    const $row = $(this);

    $row.find(inputType).each(function() {
      const $externalLoc = $(this);
      const isVerified = $externalLoc.data('verified');
      const hasDiscrepancy = $externalLoc.data('hasdiscrepancyfromyextlocation');
      const externalId = singleLocation ? $externalLoc.val() : $externalLoc.data('value');
      const indexOfExternalId = externalIds.indexOf(externalId);
      const isChosen = indexOfExternalId != null && indexOfExternalId >= 0;
      if (isVerified && hasDiscrepancy && isChosen) {
        hasMatchWithVerifiedDiscrepancyLocation = true;
      }
    });
  });

  return hasMatchWithVerifiedDiscrepancyLocation;
};

/**
 * Submit the location map, if valid, which will redirect the user to the next step
 */
yext.storm.log.gmb.GmbMatchPage.prototype.submit = function() {
  const self = this;
  const locationMatches = self.buildCurrentLocationMap();

  if (yext.storm.log.gmb.GmbMatchPage.isValid(locationMatches)) {
    this.$form.find('input.js-match-location').val(yext.JSON.stringify(locationMatches));
    this.$form.find('input.js-match-partner').val(this.partnerId);
    this.$form.find('input.js-match-goal').val(this.goalId);

    this.$form.submit();
  }
};

/**
 * Double checks that no location is matched to the same extneralId
 * and that there is only one match per location
 *
 * @param {!Array<Object>} locationMatches The array of location matches
 * @return {boolean} True if there are no errors in locationMatches
 * @suppress {deprecated}
 */
yext.storm.log.gmb.GmbMatchPage.isValid = function(locationMatches) {
  const locationIds = {};
  const externalIds = {};
  let isValid = true;

  $.each(locationMatches, function(index, locationMatchesItem) {
    const externalId = locationMatchesItem['externalId'];
    const locationId = locationMatchesItem['locationId'];
    const partnerId = locationMatchesItem['partnerId'];

    // invalid if partnerId/locationId/externalId are not provided, or has a duplicate
    if (!locationId || !partnerId || !locationMatchesItem.hasOwnProperty('externalId')
        || locationIds[locationId] || externalIds[externalId]) {
      isValid = false;
    }

    if (externalId) {
      externalIds[externalId] = true;
    }

    locationId[locationId] = true;
  });

  if (!isValid) {
    yext.notify.showError(yext.msg('Invalid input'));
  }

  return isValid;
};

/**
 * Changes any row's choice, except for the one whose locationId was provided, that had
 * previously selected the provided externalId to the add new location option
 *
 * @param {number} locationId The locationId of the location that was just matched
 * @param {number} externalId The externalId selection of the just-matched location
 */
yext.storm.log.gmb.GmbMatchPage.removeDuplicates = function(locationId, externalId) {
  $('.js-gmb-match-row').each(function() {
    const $row = $(this);

    // skip if locationId/externalId not provided, if externalId is new/skip, or if just-matched row
    if (!locationId || !externalId || externalId === 'new' || externalId === 'skip'
        || $row.data('locationId') === locationId ) {
      return;
    }

    if ($row.find('select').val() === externalId) {
      $row.find('.gumi').data('gumi').setSelected('new', false); // false prevents onChange
    }
  });
};

yext.storm.log.gmb.GmbMatchPage.prototype.showWarningBeforeSubmitDialog = function(message, title) {
  const self = this;
  const onSubmit = function() {
    self.submit();
  };
  const submitButtonText = yext.msg('Continue');
  yext.dialog.showSubmitDialog({
    onSubmit: onSubmit,
    message: message,
    title: title,
    submitButtonText: submitButtonText,
  });
};

goog.exportSymbol('yext.storm.log.gmb.initChooseAccountPage', yext.storm.log.gmb.initChooseAccountPage);
goog.exportSymbol('yext.storm.log.gmb.GmbMatchPage', yext.storm.log.gmb.GmbMatchPage);
